import React, { createContext, useContext } from 'react';

import { useLibrarySearchParams } from '../useLibrarySearchParams';

const LibrarySearchParamsContext = createContext<ReturnType<typeof useLibrarySearchParams> | null>(
  null
);

export const LibrarySearchParamsProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const searchParamsState = useLibrarySearchParams();
  return (
    <LibrarySearchParamsContext.Provider value={searchParamsState}>
      {children}
    </LibrarySearchParamsContext.Provider>
  );
};

export const useLibrarySearchParamsContext = () => {
  const ctx = useContext(LibrarySearchParamsContext);
  if (!ctx) {
    throw new Error(
      'useLibrarySearchParamsContext must be used within LibrarySearchParamsProvider'
    );
  }
  return ctx;
};
